// C:\MonProjet\BBW_DELEGUER\preprod\babyworld-backoffice\babyworld-backoffice\src\services\authenticationService.js

export const getToken = () => {
  /**
   * IMPORTANT : On utilise la clé "token" (et non "jwtToken") 
   * pour correspondre à ce qui est écrit dans votre fichier signinThunk.js
   */
  const token = localStorage.getItem("token") || null;
  return token;
};